class RetainedValuesUtils {
	populateRetainedValues(record, values) {
		values.forEach((r) => {
			r.value.forEach((v) => {
				record[v.key] = v.value;
			});
		});
		return record;
	}

	// record keys currently holding a pinned value
	getRetainedValueKeys(values) {
		let keys = [];
		(values || []).forEach((r) => {
			(r.value || []).forEach((v) => {
				if (v.key && !keys.includes(v.key)) keys.push(v.key);
			});
		});
		return keys;
	}
}
const retainedValuesUtils = new RetainedValuesUtils();
export default retainedValuesUtils;
